<template>
  <button
    type="button"
    class="w-full h-full flex items-center justify-center transition-opacity focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-1 rounded disabled:opacity-50 disabled:cursor-default"
    :class="data.length ? 'cursor-pointer hover:opacity-80' : ''"
    :title="data.length ? 'Click to view detailed trend' : ''"
    :disabled="!data.length"
    @click="$emit('click')"
  >
    <svg
      :width="width"
      :height="height"
      class="block text-violet-500 pointer-events-none"
      preserveAspectRatio="none"
    >
      <polyline
        :points="pathPoints"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import type { TrendDataPoint } from "@/stores/insights";

export default defineComponent({
  name: "TrendSparkline",
  emits: ["click"],
  props: {
    data: {
      type: Array as PropType<TrendDataPoint[]>,
      default: () => [],
    },
    width: { type: Number, default: 96 },
    height: { type: Number, default: 40 },
  },
  setup(props) {
    const pathPoints = computed(() => {
      const data = props.data;
      if (!data.length) return "";

      // With 1 point, polyline draws nothing - duplicate to show a flat line
      const points = data.length === 1 ? [data[0], data[0]] : data;
      const counts = points.map((d) => d.count);
      const min = Math.min(...counts);
      const max = Math.max(...counts);
      const range = max - min || 1;
      const padding = 2;

      const w = props.width - padding * 2;
      const h = props.height - padding * 2;
      const stepX = points.length > 1 ? w / (points.length - 1) : 0;

      return points
        .map((d, i) => {
          const x = padding + i * stepX;
          const y = padding + h - ((d.count - min) / range) * h;
          return `${x},${y}`;
        })
        .join(" ");
    });

    return { pathPoints };
  },
});
</script>
